/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::baa70854877f1cd1efb95552c3ac1694>>
 * @codegenId #lozenge
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen lozenge
 * @codegenParams { "props": { "appearance": true, "children": { "value": "props.forgeDoc.children[0].props?.text", "comment": "Lozenge should only accept plain text as children" }, "isBold": true, "maxWidth": true, "testId": true } }
 * @codegenDependency ../../../../../../../design-system/lozenge/src/Lozenge/index.tsx <<SignedSource::3589572728bc59c97608c770f14dd1fe>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import PlatformLozenge from '@atlaskit/lozenge';
export var Lozenge = function Lozenge(props) {
  var _props$forgeDoc$child;
  var _ref = props.forgeDoc.props,
    appearance = _ref.appearance,
    isBold = _ref.isBold,
    maxWidth = _ref.maxWidth,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(PlatformLozenge, {
    appearance: appearance
    // Lozenge should only accept plain text as children
    ,
    children: (_props$forgeDoc$child = props.forgeDoc.children[0].props) === null || _props$forgeDoc$child === void 0 ? void 0 : _props$forgeDoc$child.text,
    isBold: isBold,
    maxWidth: maxWidth,
    testId: testId
  });
};
/**
 * @codegenEnd
 */